// extracted by mini-css-extract-plugin
export default {"bottomPanel":"AdminManagerBottomPanel_bottomPanel__-yzAQ"};